import React, { useMemo } from "react";
import { useHistory } from "react-router";

import { Button, OnlineLink, TableTooltip } from "components";

import { ReactComponent as PencilEditIcon } from "static/images/pencil_edit.svg";

const WARNING_MESSAGE =
	"WARNING: The edit function should only be used to edit Schedule A pricing or revenue share when an error was made when setting up the Schedule A. Do not use this function to create a new Schedule A.";

type ScheduleATableActionsProps = {
	row: { [key: string]: any };
	isEditable: boolean;
};

const ScheduleATableActions = ({
	row,
	isEditable,
}: ScheduleATableActionsProps) => {
	const history = useHistory();
	const scheduleA = row?.original;

	const editPath = useMemo(
		() => `${history.location.pathname}/${scheduleA.id}`,
		[history.location.pathname, scheduleA.id],
	);

	return (
		<div className="d-flex align-items-center">
			<TableTooltip
				text={WARNING_MESSAGE}
				placement="top"
				className="text-warning"
			>
				<div>
					<Button
						btnIcon
						icon={<PencilEditIcon />}
						onClick={e => e.stopPropagation()}
						as={OnlineLink}
						to={editPath}
						variant="secondary"
						size="sm"
						className={isEditable ? "" : "disabled"}
						disabled={!isEditable}
					/>
				</div>
			</TableTooltip>
		</div>
	);
};

export default ScheduleATableActions;
